// test120
(120 && 0);
